import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the error state domain
 */

const selectErrorDomain = state => state.toastReducer || initialState;

const selectTwoFactorAuthenticationValue = state =>
  state.toastReducer && state.toastReducer.isTwoFactorAuthenticated;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Error
 */

const makeSelectError = () =>
  createSelector(
    selectErrorDomain,
    substate => substate,
  );

export const twoFactorAuthenticationSelector = () =>
  createSelector(
    selectTwoFactorAuthenticationValue,
    substate => substate,
  );

export default makeSelectError;
export { selectErrorDomain };
